import * as Styled from './ProviderForm.styled';
import { Spacer } from '../../../../helpers/genericStyles';
import { Text } from '../../../ToolkitV2/Text/Text';
import { Checkbox } from '../../../Toolkit/Inputs/Checkbox';
import { FinanceCalculator } from '../../components/FinanceCalculator/FinanceCalculator';
import { ContactFields } from '../../components/Panels/PersonalDetails/PersonalDetails';
import { StepLayout } from './StepLayout/StepLayout';
import type { QueryParameters } from '../../queries/schema/carFinance.schema';

type Props = {
  query: QueryParameters;
  introConsent: boolean;
  setIntroConsent: (value: boolean) => void;
  currentStep: number;
  totalSteps: number;
  onContinue: () => void;
  adId: string;
  showOutstandingFinance?: boolean;
  maxFinanceAmount?: number;
  isValidating?: boolean;
};

const Step1Content = ({
  query,
  introConsent,
  setIntroConsent,
  currentStep,
  totalSteps,
  onContinue,
  adId,
  showOutstandingFinance = false,
  maxFinanceAmount,
  isValidating = false,
}: Props) => (
  <StepLayout
    title="Calculate monthly payments"
    currentStep={currentStep}
    totalSteps={totalSteps}
  >
    <FinanceCalculator
      dealerId={query.dealerId}
      financeHouse={query.provider}
      minimumDepositPercentage={query.minimumDepositPercentage}
      minimumDepositValue={query.minimumDepositValue}
      adId={adId}
      showOutstandingFinance={showOutstandingFinance}
      maxFinanceAmount={maxFinanceAmount}
    />
    <Styled.YourDetailsSection>
      <Text forwardedAs="h3" size="M16" weight="bold" color="GREY_DARKER">
        Your details
      </Text>
      <Spacer marginBottom="M16" />
      <ContactFields />
    </Styled.YourDetailsSection>
    <Styled.ConsentAndActionRow>
      <Checkbox
        name="introConsent"
        checked={introConsent}
        onChange={setIntroConsent}
        labelSize="s"
        willUseSubText={false}
        label={<>I agree to share my details with {query.dealerName}.</>}
      />
      <Styled.ContinueButton
        type="button"
        disabled={!introConsent || isValidating}
        onClick={onContinue}
      >
        Continue to full application
      </Styled.ContinueButton>
    </Styled.ConsentAndActionRow>
  </StepLayout>
);

export { Step1Content };
